import { Menu, SxProps, Theme } from "@mui/material";
import { Box } from "@mui/system";
import { FC, useState } from "react";
import { TriggerElement } from "../../models/base";

interface CustomTooltipProps {
  triggerElement: TriggerElement;
  maxWidth?: string;
  className?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CustomTooltip: FC<CustomTooltipProps> = ({
  triggerElement,
  maxWidth,
  children,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {triggerElement(handleClick, open)}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} {...props}>
        <Box sx={{ maxWidth }}>{children}</Box>
      </Menu>
    </>
  );
};

export default CustomTooltip;
